//import React, { useState } from "react";
import {
    Box,
    Container,
    Typography,
    Paper,
    //Card,
    //CardContent,
    Alert,
    useTheme
} from "@mui/material";
//import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

import HotelIcon from '@mui/icons-material/Hotel';
//import EuroIcon from '@mui/icons-material/Euro';
import chambre_1 from "../../../assets/img/rooms/chambre-1.jpeg";
import chambre_2 from "../../../assets/img/rooms/chambre-2.jpeg";
import chambre_3 from "../../../assets/img/rooms/chambre-3.jpeg";
import chambre_4 from "../../../assets/img/rooms/chambre-4.jpeg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useMediaQuery } from "@mui/material";

const rooms = [
    { img: chambre_1 },
    { img: chambre_2 },
    { img: chambre_3 },
    { img: chambre_4 },
];



const StayAtPepiniere: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));



    return (
        <>
            {/* Section Dormir au Domaine */}
            <Container maxWidth="md" sx={{ mb: 4 }}>
                <Paper elevation={3} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3 }}>
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                            <HotelIcon sx={{ mr: 2, color: 'primary.main', fontSize: 30 }} />
                            <Typography variant="h5">Dormir au Domaine de la Pépinière</Typography>
                        </Box>
                        <Box sx={{ mb: 2 }}>
                            <Swiper
                                modules={[Pagination, Navigation]}
                                spaceBetween={16}
                                slidesPerView={isMobile ? 1.07 : 1}
                                pagination={isMobile ? { clickable: true } : false}
                                navigation={!isMobile}
                                style={{
                                    paddingBottom: isMobile ? 32 : 0,
                                    "--swiper-navigation-color": "#4c775b",
                                    "--swiper-pagination-color": theme.palette.primary.main,
                                    "--swiper-pagination-bullet-inactive-color": theme.palette.primary.light,
                                    "--swiper-pagination-bullet-inactive-opacity": "0.4",
                                }}
                            >
                                {rooms.map((item) => (
                                    <SwiperSlide key={item.img}>
                                        <img
                                            src={item.img}
                                            alt="Chambre"
                                            style={{
                                                borderRadius: 3,
                                                width: "100%",
                                                height: isMobile ? 250 : 500,
                                                objectFit: "cover",
                                            }}
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </Box>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                            Le Domaine de la Pépinière (lieu de la cérémonie laïque, de la réception et du brunch), dispose de nombreux couchages.
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                            Nous vous proposons de dormir sur place afin d'éviter les trajets en voiture entre la réception et le brunch et profiter de la soirée avec nous sereinement.
                        </Typography>
                       {/* <Card variant="outlined" sx={{ mb: 2, mt: 3 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <EuroIcon sx={{ mr: 2, color: 'primary.main', fontSize: 30 }} />
                                    <Typography variant="h6">Participation</Typography>
                                </Box>
                                <Typography variant="body1">
                                    Une participation de 30€ par personne et par nuit est demandée pour aider à couvrir les frais d'hébergement.
                                </Typography>
                            </CardContent>
                        </Card>*/}
                        <Alert severity="info" sx={{ mt: 3 }}>
                            <strong>Important :</strong> Pensez à prendre des serviettes de bain, elles ne sont pas comprises au domaine. Les draps, eux, sont compris.
                        </Alert>
                    </Box>
                </Paper>
            </Container>

        </>
    );
};

export default StayAtPepiniere;
